/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Memory_Edit_EntryInputs */



/**
* | output |
* | --- |
* | "Edit this entry" |
*
* @param {Memory_Edit_EntryInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const memory_edit_entry = /** @type {((inputs?: Memory_Edit_EntryInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Memory_Edit_EntryInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Diesen Eintrag bearbeiten")
	return /** @type {LocalizedString} */ ("Edit this entry")
});